import {
    LogoutProps,
} from './types'
import LogoutView from './LogoutView'
import React from 'react'
const Logout: React.FC<LogoutProps> = (props: LogoutProps): React.ReactElement => {
    const {logout} = props
    return <LogoutView onClickHandler={logout} />
}
export default Logout
